import React from 'react';
import { Line } from 'recharts';

const TeamBlock = ({ data }) => {
    const { img, name, tag, facebook, twitter, instagram, linkedin } = data;
   console.log(data)
    return (
        <div className="team-style-one col-lg-4 col-md-4 col-sm-6">
            <div className="teambox">
                <img src={img} alt="img" />
                <div className="teambox-inner">
                    <div className="team-social">
                        {/* <ul>
                            <li className="facebook"><a  href={facebook} target='_blank'><i className="bi bi-facebook"></i></a></li>
                            <li className="twitter"><a href={twitter} target='_blank'><i className="bi bi-twitter"></i></a></li>
                            <li className="instagram"><a href={instagram} target='_blank'><i className="bi bi-instagram"></i></a></li>
                            <li className="linkedin"><a href={linkedin} target='_blank'><i className="bi bi-linkedin"></i></a></li>
                        </ul> */}
                        <ul>
                            {facebook && (
                                <li className="facebook">
                                    <a href={facebook} target="_blank" rel="noopener noreferrer">
                                        <i className="bi bi-facebook"></i>
                                    </a>
                                </li>
                            )}

                            {twitter && (
                                <li className="twitter">
                                    <a href={twitter} target="_blank" rel="noopener noreferrer">
                                        <i className="bi bi-twitter"></i>
                                    </a>
                                </li>
                            )}

                            {instagram && (
                                <li className="instagram">
                                    <a href={instagram} target="_blank" rel="noopener noreferrer">
                                        <i className="bi bi-instagram"></i>
                                    </a>
                                </li>
                            )}

                            {linkedin && (
                                <li className="linkedin">
                                    <a href={linkedin} target="_blank" rel="noopener noreferrer">
                                        <i className="bi bi-linkedin"></i>
                                    </a>
                                </li>
                            )}
                        </ul>


                    </div>
                    <div className="teambox-intro text-center">
                        <h5>{name}</h5>
                        <p>{tag}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeamBlock;